export { provider as baseURL } from 'constants/apiBaseUrls'

export { default as Schema } from 'schemas/ProviderId'

export const url = ({ id }) => `/v1/providers/${id}/visits/queue`
